export default __webpack_public_path__ + "static/media/Cleaning-Equipment.c92dfb06.jpg";